export default function log({ next, to }: { [key: string]: any }) {
  return next()
}
